
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor-selector",
      function () {
        return require("private-next-pages/vendor-selector.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor-selector"])
      });
    }
  